/* eslint-disable */
const axios = require('axios').default;
import apiosWithToken from "./apiosWithToken"

export default {
    getOptions() {
        return apiosWithToken.get(`/activities/options/`)
    },
    getWarmups() {
        return apiosWithToken.get('/activities/warmups/as-option/')
    },
    getStretchFlows() {
        return apiosWithToken.get('/activities/stretch-flows/as-option/')
    },
    createSeries(data) {
        if (data)
            return apiosWithToken.post(`/activities/options/`, data)
    },
    createEmptyActivity(activity, type) {
        return apiosWithToken.post(`/activities/${type}s/`, activity)
    },
    getActivity(id, data = '') {
        const activityType = data['type'] == 'stretch_flow' ? 'stretch-flow' : data['type']
        return apiosWithToken.get(`/activities/${activityType}s/${id}`)
    },
    updateActivity(id, data) {
        const activityType = data['type'] == 'stretch_flow' ? 'stretch-flow' : data['type']
        return apiosWithToken.put(`/activities/${activityType}s/${id}/`, data)
    },
    getEquipmentsCategories() {
        return apiosWithToken.get('/activities/equipment/categories/?limit=20')
    },
    getActivities() {
        return apiosWithToken.get('/workouts/')
    },
    createSelectedEquipments(equipments, activity) {
        const activityType = activity.type == 'stretch_flow' ? 'stretch-flow' : activity.type
        const promises = equipments.map(equipment => {
            if (equipment) {
                if (equipment.selected) {

                    return apiosWithToken.put(`/activities/${activity.id}/selected/equipments/${equipment.e_id}/`, {
                        activity: activity.id,
                        selected_option: equipment.selected_option,
                        equipment: equipment.id,
                    })
                } else {

                    return apiosWithToken.post(`/activities/${activity.id}/selected/equipments/`, {
                        activity: activity.id,
                        selected_option: equipment.selected_option,
                        equipment: equipment.id,
                    })
                }
            }

        })
        return Promise.all(promises)

    },
    deleteSelectedEquipment(activity, id) {
        return apiosWithToken.delete(`/activities/${activity.id}/selected/equipments/${id}/`)
    },
    createProduction(activity, data, prod_type) {
        const activityType = activity.type == 'stretch_flow' ? 'stretch-flow' : activity.type
        return apiosWithToken.post(`/activities/${prod_type}/`, data)
    },
    updateProduction(activity, data, prod_type) {
        const activityType = activity.type == 'stretch_flow' ? 'stretch-flow' : activity.type
        return apiosWithToken.put(`/activities/${prod_type}/${activity.id}/`, data)
    },
    updateFlag(id, data) {
        const activityType = data['type'] == 'stretch_flow' ? 'stretch-flow' : data['type']

        return apiosWithToken.put(`/activities/${activityType}s/${id}/`, data)
    },
    getListByType(data) {
        const activityType = data['type'] == 'stretch_flow' ? 'stretch-flow' : data['type']
        var url = `/${activityType}/all/`
        var offset = data.offset
        if (data.offset == 1) {
            offset = data.offset - 1
        } else {
            offset = data.offset - 1
            offset = offset * data.limit
        }
        if (activityType == 'activities') {
            url = `/${activityType}/all/?&limit=${data.limit}&offset=${offset}`
            if (data.sorting) {
                url = `/${activityType}/all/?&limit=${data.limit}&offset=${offset}&ordering=${data.sorting}`
            }
            if (data.search) {
                url = `/${activityType}/all/?&limit=${data.limit}&offset=${offset}&search=${data.search}`
                if (data.sorting) {
                    url = `/${activityType}/all/?&limit=${data.limit}&offset=${offset}&search=${data.search}&ordering=${data.sorting}`
                }
            }
        }

        if (activityType != 'activities') {
            url = `/activities/${activityType}?&limit=${data.limit}&offset=${offset}`
            if (data.sorting) {
                url = `/activities/${activityType}?&limit=${data.limit}&offset=${offset}&ordering=${data.sorting}`
            }
            if (data.search) {
                url = `/activities/${activityType}?&limit=${data.limit}&offset=${offset}&search=${data.search}`
                if (data.sorting) {
                    url = `/activities/${activityType}?&limit=${data.limit}&offset=${offset}&search=${data.search}&ordering=${data.sorting}`
                }
            }
        }
        if (data.type == 'todo') {
            if (data.status == 'activities') {
                url = `/activities/all/?&limit=${data.limit}&offset=${offset}`
                if (data.sorting) {
                    url = `/activities/all/?&limit=${data.limit}&offset=${offset}&ordering=${data.sorting}`
                }
                if (data.search) {
                    url = `/activities/all/?&limit=${data.limit}&offset=${offset}&search=${data.search}`
                    if (data.sorting) {
                        url = `/activities/all/?&limit=${data.limit}&offset=${offset}&search=${data.search}&ordering=${data.sorting}`
                    }
                }
            } else {
                url = `/activities/all/?status=${data.status}&limit=${data.limit}&offset=${offset}`
                if (data.sorting) {
                    url = `/activities/all/?status=${data.status}&limit=${data.limit}&offset=${offset}&ordering=${data.sorting}`
                }
                if (data.search) {
                    url = `/activities/all/?status=${data.status}&limit=${data.limit}&offset=${offset}&search=${data.search}`
                    if (data.sorting) {
                        url = `/activities/all/?status=${data.status}&limit=${data.limit}&offset=${offset}&search=${data.search}&ordering=${data.sorting}`
                    }
                }
            }
        }

        return apiosWithToken.get(`${url}`)
    },
    getCurrentWarmup(id) {
        return apiosWithToken.get(`/warmups/${id}`)
    },
    getCurrentStrechflow(id) {
        return apiosWithToken.get(`/stretch-flows/${id}`)
    },
    getCurrentVideos(id, type) {
        const activityType = type == 'stretch_flow' ? 'stretch-flow' : type
        return apiosWithToken.get(`/activities/video-components/activity/${id}`)
    },
    updateVideo(video, type) {
        const activityType = type == 'stretch_flow' ? 'stretch-flow' : type
        return apiosWithToken.put(`/activities/video-components/${video.id}/`, video)
    },
    getUsers() {
        return apiosWithToken.get(`/organizations/users/production/`)
    },
    getJourney() {
        return apiosWithToken.get(`/settings/journey/`)
    },
    getJourneyReport(payload) {
        return apiosWithToken.post(`/settings/journey/report/`, payload)
    },
}
